import classNames from 'classnames';
import React from 'react';
import Masonry from 'react-masonry-component';

const masonryOptions = {
  transitionDuration: 0,
};
interface CardGridProps {
  /** Cards to display in a grid. */
  children: React.ReactNode;
  /** classes to style component. */
  className?: string;
  /** Caption/Title/Header of the Grid. */
  header?: React.ReactNode;
}

/** Orders a any amount of Cards in a grid. */
const CardGrid = ({ children, className, header }: CardGridProps) => {
  return (
    <div className={classNames(className, 'ce ce-card-grid')}>
      {header}
      <div className="masonry-wrapper">
        <Masonry
          options={masonryOptions} // default {}
          disableImagesLoaded={false} // default false
          updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
        >
          {children}
        </Masonry>
      </div>
    </div>
  );
};

CardGrid.defaultProps = {
  className: null,
  header: null,
};

export default CardGrid;
